import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../reducer';
import { selectUserSettingsState } from '../selectors';

export const selectDataFeeds = createSelector(selectUserSettingsState, (userSettings) => userSettings.dataFeeds);

export const selectUserPreferencesByPath = <TPreferences>(path: string) => (state: RootState): TPreferences | null =>
  (state.userSettings.preferences[path] as TPreferences | null) ?? null;

export const selectIsUserPreferencesPathLoaded = (path: string) => (state: RootState): boolean =>
  state.userSettings.loadedPreferencePaths.includes(path);

export const selectPreMigrationVersion = (path: string) => (state: RootState): number | undefined =>
  state.userSettings.preMigrationVersions[path];
